"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const reactstrap_1 = require("reactstrap");
const change_case_1 = require("change-case");
exports.EmailCanvasBlockContentKeyListItem = ({ contentField, isActive, isLast, onSelect }) => {
    const prettyCfId = react_1.useMemo(() => {
        return change_case_1.sentenceCase(contentField.id);
    }, [contentField.id]);
    const prettyCfType = react_1.useMemo(() => {
        return contentField.type === 'url' || contentField.type === 'html'
            ? contentField.type.toUpperCase()
            : change_case_1.sentenceCase(contentField.type);
    }, [contentField.type]);
    return (react_1.default.createElement(reactstrap_1.Card, { tag: !isActive ? 'a' : undefined, href: !isActive ? '#' : undefined, onClick: e => {
            e.preventDefault();
            if (!isActive) {
                onSelect();
            }
        }, className: react_2.classnames('p-2', !isLast && 'mb-2', !isActive && 'hover-underline') },
        react_1.default.createElement(react_2.OsmosysTooltip, { label: isActive
                ? 'This is the current source of content'
                : 'Select this as the source of content' },
            react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EmailCanvasBlockContentKeyListItem", flexRowFilled: true },
                react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EmailCanvasBlockContentKeyListItem.left", flexColCenteredFilled: true },
                    react_1.default.createElement("p", { className: react_2.classnames('lead m-0 font-weight-bold', isActive ? 'text-muted' : 'text-primary') }, prettyCfId)),
                react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EmailCanvasBlockContentKeyListItem.right", flexColCentered: true },
                    react_1.default.createElement("p", { className: "text-muted m-0 small" }, prettyCfType))))));
};
//# sourceMappingURL=ContentKeyListItem.js.map